import { apiClient } from './client'
import endpoints from './endpoints'
import { unwrapVoid } from './normalize'

// Same route and verb as the read, but a different contract: with `create=true` the backend
// only enqueues the detection and answers a message-only envelope (the result reaches the user
// by email), so this must not be normalized as a collection.
export default async function createEligibilityCheck({
  farmId,
}: {
  farmId: string
}): Promise<void> {
  const response = await apiClient.get(endpoints.v2.farms.eligibilityCheck(farmId), {
    params: { create: true },
  })
  return unwrapVoid(response)
}
